function fn_comp_visual() {

    jQuery(function($) {
        var el, set;


        // App
        var Application;
        Application = {

            settings: {
                sliderAutoplaySpeed: 5000,
                sliderSpeed: 600
            },

            elements: {
                slider: $('#slick')
            },

            init: function () {
                set = this.settings;
                el = this.elements;

                this.slider();
            },

            /**
             * Slider
             */
            slider: function () {

                el.slider.on('init');
                $("#content").data("lng-prev");
                $("#content").data("lng-next");
                el.slider.slick({
                    prevArrow: '<button type="button" class="slick-prev"><span>' + $("#slick").data("lng-prev") + '</span></button>',
                    nextArrow: '<button type="button" class="slick-next"><span>' + $("#slick").data("lng-next") + '</span></button>',
                    arrows: true,
                    dots: false,
                    autoplay: true,
                    autoplaySpeed: set.sliderAutoplaySpeed,
                    fade: true,
                    speed: set.sliderSpeed,
                    pauseOnHover: false
                });

                el.slider.on({
                    beforeChange: function (event, slick, currentSlide, nextSlide) {
                        if ($('.visual-switch--js').hasClass('visual-switch--js_main')) {

                            //$('#main_header').find('.button').removeClass('slide' + (currentSlide + 1) + '-current').addClass('slide' + (nextSlide + 1) + '-current');
                            //var color = $(this).find(".slick-active").next().find('[data-color-slider]').data('color-slider');
                            var color = $(this).find('[data-slick-index=' + nextSlide + ']').find('[data-color-slider]').data('color-slider');
                            $('#main_header').find('.button').removeClass('button-blue button-orange button-green').addClass('button-' + color);

                            $('.visual-switch').find('[data-color]').removeClass("active");
                            $('.visual-switch').find('[data-color=' + color + ']').addClass("active");

                        } else {

                            $('.visual-switch').removeClass('slide' + (currentSlide + 1) + '-current').addClass('slide' + (nextSlide + 1) + '-current')

                        }
                    }
                });
            }
        };


        //Init
        Application.init();

        $('.visual-switch--js').on('click', 'a', function( e ) {
            e.preventDefault();

            if ($('.visual-switch--js').hasClass('visual-switch--js_main')) {
                var color = $(this).attr('data-color');

                var slide = $('#visual').find('[data-color-slider=' + color + ']').parent();

                var slideIndex = slide.index();

            } else {

                var slideIndex = $(this).closest('li').index();

            }

            $('#slick').slick( 'slickGoTo', parseInt( slideIndex ) );
        });

        $(".visual-text").hover(
            function() {
                var $this = $(this).find(".plus");
                $this.parent().addClass("active");
                $this.text($("#visual").data("lng-more"));
                $this.parent().parent().parent().addClass("hide");
                $('#slick').slick('slickPause');
            }, function() {
                var $this = $(this).find(".plus");
                $this.parent().removeClass("active");
                $this.html("<span class=\"icon-plus\"></span>");
                $this.parent().parent().parent().removeClass("hide");
                $('#slick').slick('slickPlay');
            }
        );
    });

    $('#slick2').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        speed: 1200,
        pauseOnHover: false,
        pauseOnDotsHover: true
    });

}